module.exports = __webpack_public_path__ + "static/media/video.bea042dd.mp4";